<template>
    <div class="cms-main-style">
        <el-container style="height:100vh;">
            <el-aside  class="cms-navmenu" width="321px">
                <learning-center-nav-menu :textContentDetail.sync="textContentDetail"></learning-center-nav-menu>
            </el-aside>
            <el-main class="cms-content">
                <LearningCenterEditorContent :textContentDetail.sync="textContentDetail"/>
            </el-main>
        </el-container>
    </div>
</template>

<script>
import LearningCenterNavMenu from '@/components/LearningCenter/LearningCenterNavMenu'
import LearningCenterEditorContent from '@/components/LearningCenter/LearningCenterEditorContent.vue'
import { eventBus } from '@/main'

export default {
    name: 'LearningCenter',
    components: {
        LearningCenterNavMenu,
        LearningCenterEditorContent
    },
    data () {
        return {
            textContentDetail: {
                titleList: [],
                detail: {},
                subTitleDetail: {
                    id: '',
                    text: ''
                }
            }
        }
    },
    created () {
        eventBus.$emit('setDefaultPadding', false)
    },
    destroyed () {
        eventBus.$emit('setDefaultPadding', true)
    }
}
</script>

<style lang="scss">
.cms-main-style {
    font-family: 'Kanit', sans-serif;
    .cms-content{
        padding: 0px;
    }
}
</style>
